<template>
    <div id="popup" :class="{'active':active}">
        <div id="popupContent">
            <div class="header">
                <h1>{{title}}</h1>
            </div>
            <div class="popupInfo" v-html="text">

            </div>
            <div class="pageOptions">
                <Btn ico="valide" :text="btn[0]" @click="success" v-if="btn[0]"></Btn>
                <Btn ico="valide" :text="btn[2]" @click="successSecond" v-if="btn[2]"></Btn>
                <Btn ico="times" color="red" @click="error" v-if="btn[1]"></Btn>
            </div>
        </div>
        <div id="popupBackground"></div>
    </div>
</template>

<script>
    import Btn from "@/components/Btn";
    export default {
        name: "Popup",
        components: {Btn},
        props : {
            title:"",
            text:"",
            btn:"",
            active:false
        },
        methods : {
            success() {
                this.$emit("success");
            },
            successSecond() {
                this.$emit("successSecond");
            },
            error() {
                this.$emit("error");
            }
        }
    }
</script>

<style scoped>

</style>